import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import longDarkLogo from '../../../../public/statics/images/logos/eon-logo-long-dark.png';
import longLogo from '../../../../public/statics/images/logos/eon-logo-long.png';
export const EONLogo = t0 => {
  const $ = _c(5);
  const {
    className,
    dark
  } = t0;
  const t1 = dark ? longDarkLogo : longLogo;
  const t2 = dark ? 50 : 56;
  const t3 = dark ? 18 : 24;
  let t4;
  if ($[0] !== className || $[1] !== t1 || $[2] !== t2 || $[3] !== t3) {
    t4 = <Image priority={true} className={className} src={t1} width={t2} height={t3} alt="Eon" />;
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};